/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Close_Aria_LabelInputs */

const en_merge_event_group_close_aria_label = /** @type {(inputs: Merge_Event_Group_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close dialog`)
};

const fr_merge_event_group_close_aria_label = /** @type {(inputs: Merge_Event_Group_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la boite de dialogue`)
};

const de_merge_event_group_close_aria_label = /** @type {(inputs: Merge_Event_Group_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog schließen`)
};

const it_merge_event_group_close_aria_label = /** @type {(inputs: Merge_Event_Group_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi finestra di dialogo`)
};

const ru_merge_event_group_close_aria_label = /** @type {(inputs: Merge_Event_Group_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть диалог`)
};

const es_merge_event_group_close_aria_label = /** @type {(inputs: Merge_Event_Group_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar diálogo`)
};

const zh_cn2_merge_event_group_close_aria_label = /** @type {(inputs: Merge_Event_Group_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭对话框`)
};

const ja_merge_event_group_close_aria_label = /** @type {(inputs: Merge_Event_Group_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダイアログを閉じる`)
};

const hi_merge_event_group_close_aria_label = /** @type {(inputs: Merge_Event_Group_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद बंद करें`)
};

const pt_pt2_merge_event_group_close_aria_label = /** @type {(inputs: Merge_Event_Group_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar caixa de diálogo`)
};

/**
* | output |
* | --- |
* | "Close dialog" |
*
* @param {Merge_Event_Group_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_close_aria_label = /** @type {((inputs?: Merge_Event_Group_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_close_aria_label(inputs)
	if (locale === "de") return de_merge_event_group_close_aria_label(inputs)
	if (locale === "it") return it_merge_event_group_close_aria_label(inputs)
	if (locale === "ru") return ru_merge_event_group_close_aria_label(inputs)
	if (locale === "es") return es_merge_event_group_close_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_close_aria_label(inputs)
	if (locale === "ja") return ja_merge_event_group_close_aria_label(inputs)
	if (locale === "hi") return hi_merge_event_group_close_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_close_aria_label(inputs)
	return en_merge_event_group_close_aria_label(inputs)
});